import { DISABLED_DISCIPLINE } from "../../global";

export const Disciplinekeys = [
  { id: 1, label: "Electro-technical" },
  { id: 2, label: "Others" },
  { id: 3, label: "mass & volume" },
  { id: 4, label: "thermal" },
  { id: 5, label: "bioMedical" },
];

export const Discipline = [
  { id: 1, label: "Chemical" },
  { id: 2, label: "Biological" },
  { id: 3, label: "Mechanical" },
  { id: 4, label: "Electrical" },
  { id: 5, label: "Electronics" },
  { id: 6, label: "Fluid Flow" },
  { id: 7, label: "Forensic" },
  { id: 8, label: "Non-Destructive (NDT)" },
  { id: 9, label: "Photometry" },
  { id: 10, label: "Radiological" },
  { id: 11, label: "Diagnostic Radiology QA Testing" },
  { id: 12, label: "Software & IT System" },
];

export const DisciplineOptions = Discipline.filter(
  (item) => !DISABLED_DISCIPLINE.includes(item.label)
);

export const DispatchModeOptions = [
  { id: 1, label: "Courier" },
  { id: 2, label: "By Hand Delivery" },
];